import { sessionSchema, Session } from './schema';

const sessionTokenVerify = (session: Session) => {
  if (session.accessTokenPayload.exp * 1000 < Date.now()) {
    return null;
  }

  return session;
};

export const parseRawSession = (rawSession: string): Session | null => {
  if (!rawSession) return null;

  const session = sessionSchema.parse(JSON.parse(rawSession));

  return session ? sessionTokenVerify(session) : null;
};
